module.exports = __webpack_public_path__ + "img/icon_system_dictionary_external.da71450c.svg";